import { http } from "@/http";
import { imgServe } from "@/imageServe";

const PATH = "app/reports/visits";

function getCustomerHeaders() {
  return {
    headers: {
      customer: localStorage.getItem("__uuid"),
    },
  };
}

function getUploadHeaders(extraHeaders = {}) {
  return {
    headers: {
      BASE_PATH: process.env.VUE_APP_BASE_API_URL,
      __company: localStorage.getItem("__company"),
      ...extraHeaders,
    },
  };
}

class ReportVisitItemsService {
  async getAll(reportId) {
    return http.get(PATH.concat('/').concat(reportId).concat("/items"));
  }

  async getById(reportId, itemId) {
    return http.get(PATH.concat('/').concat(reportId).concat("/items/").concat(itemId));
  }

  async create(reportId, payload) {
    return http.post(
      PATH.concat('/').concat(reportId).concat("/items"),
      payload,
      getCustomerHeaders()
    );
  }

  async update(reportId, itemId, payload) {
    return http.post(
      PATH.concat('/').concat(reportId).concat("/items/").concat(itemId).concat("/edit"),
      payload,
      getCustomerHeaders()
    );
  }

  async remove(reportId, itemId) {
    return http.patch(
      PATH.concat('/').concat(reportId).concat("/items/").concat(itemId).concat("/remove"),
      null,
      getCustomerHeaders()
    );
  }

  async reorder(reportId, items) {
    return http.patch(
      PATH.concat('/').concat(reportId).concat("/items/reorder"),
      { items },
      getCustomerHeaders()
    );
  }

  async savePhoto(file) {
    return imgServe.post("new-file", { file }, getUploadHeaders());
  }

  async replacePhoto(file, currentPath) {
    return imgServe.post(
      "replace-file",
      { file },
      getUploadHeaders({
        __company_path: currentPath,
      })
    );
  }
}

export default new ReportVisitItemsService();
export { PATH };